module.exports = __webpack_public_path__ + "bg_with-white.2w7KY1og.svg";